<div class="content-container" [tslSpinner]="isRedirecting">
    <div class="interstital-content">
        <h1 class="tds-text--h1-alt" i18n="@@MFAEnrollment" t="MFAEnrollment">Multi-Factor Authentication Enrollment
        </h1>
        <p class="instructions" i18n="@@MFAInvalidSessionInstructions" t="MFAInvalidSessionInstructions">
            Our system detected that you are enrolled into multi-factor authentication. Your current session is
            in-valid, please re-login with multi-factor authentication!
        </p>
        <div class="action-container">
            <button (click)="onAuthenticateWithMFA()" tsl-button color="blue" filled size="medium"
                i18n="@@AuthenticateWithMFA" t="AuthenticateWithMFA">Authenticate</button>
        </div>
    </div>
</div>